import { render, staticRenderFns } from "./IdaAcademyHomepage.vue?vue&type=template&id=0b3598c3&scoped=true"
import script from "./IdaAcademyHomepage.vue?vue&type=script&lang=js"
export * from "./IdaAcademyHomepage.vue?vue&type=script&lang=js"
import style0 from "./IdaAcademyHomepage.vue?vue&type=style&index=0&id=0b3598c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3598c3",
  null
  
)

export default component.exports